import React from "react"
import { useParams } from "react-router-dom"
import { getChapterMeta, isLiveChapter } from "../../../lib/chapters"
import NotFound from "../../../pages/NotFound"
import ChapterPage from "./ChapterPage"
import ChapterComingSoonPage from "./ChapterComingSoonPage"

const ChapterRouter: React.FC = () => {
  const { slug } = useParams<{ slug: string }>()

  if (!slug) return <NotFound />

  const meta = getChapterMeta(slug)
  if (!meta) return <NotFound />

  if (isLiveChapter(slug)) {
    return <ChapterPage slug={slug} />
  }

  return <ChapterComingSoonPage slug={slug} />
}

export default ChapterRouter
